import { openOnboardingDialog } from "@components/utils/OnboardingDialog/utils";
import { AuthSource, useStatsigTracking } from "@configs/statsig";
import { OnboardMode } from "@constants/misc";
import useUserMode from "@hooks/useUserMode";
import { useGameGateway } from "@views/HomePage/hooks";
import { Banner, GameModel } from "kz-ui-sdk";
import React from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { BaseBanner } from "..";

interface GameBannerProps {
  banner: Banner;
  game: GameModel;
  claimable?: boolean;
}

const GameBanner: React.FC<GameBannerProps> = (props) => {
  const { banner, game, claimable } = props;

  const { isMember } = useUserMode();

  const { open } = useGameGateway();

  const { t } = useTranslation();

  const { trackAuthClick } = useStatsigTracking();

  const handleClick = () => {
    if (isMember) {
      if (game.isMaintenance) {
        toast.error(t("Game is not available at the moment. Please try again later."));
        return;
      }
      open(game);
    } else {
      trackAuthClick(AuthSource.MINI_PROMOTION_GAME_BANNER);
      openOnboardingDialog({
        mode: OnboardMode.REGISTER,
      });
    }
  };
  return (
    <BaseBanner
      onClick={handleClick}
      banner={banner}
      claimable={claimable}
    />
  );
};

export default GameBanner;
